export const reduceNumberSum = (nums: number[], initialValue = 0): number => nums.reduce((previousValue, currentValue) =>
  (previousValue + (currentValue ?? 0)), initialValue);

export const getNaturalNumberArrayFromNTillM = (n: number, m: number): number[] => {
  if (n > m) {
    throw Error('getNaturalNumberArrayFromNTillM() | n cannot be greater than m');
  }
  const arr: number[] = [];
  for (let i = n; i <= m; i++) {
    arr.push(i);
  }
  return arr;
};
